import type { Product } from '@/api/getProductList'
import type { VipInfo } from '@/api/getVipInfo'
import type { LoaderFunction } from 'react-router'
import { getProductList } from '@/api/getProductList'
import { getVipInfo } from '@/api/getVipInfo'

export interface HomeLoaderData {
  products: Product[]
  vipInfo: VipInfo
}

const loader: LoaderFunction = async ({ params }) => {
  console.log('Home page params', params)
  const products = await getProductList()
  // console.log('Home page products', products)
  const vipInfo = await getVipInfo()
  return {
    products,
    vipInfo,
  }
}

export default loader
